<template>
  <div class="RadioSelect mx-2">
    <div v-for="collection in shownCollections" class="my-3">
      <label
        :for="labelName(collection.value)"
        class="RadioSelect_label font-normal mb-0 flex items-center"
        :class="isSelected(collection.value) && 'active'"
      >
        <input
          class="offscreen"
          type="radio"
          :id="labelName(collection.value)"
          :value="collection.value"
          @change="toggleSelect"
          :name="collection.value"
          :checked="selected == collection.value"
        />

        <div class="inline-block mr-2 radio-ico">
          <span class="fa-layers fa-2x">
            <i class="fal fa-circle" data-fa-transform=""></i>
            <i class="fas fa-circle radio-is-selected" data-fa-transform="shrink-4"></i>
          </span>
        </div>

        {{ collection.title }}
      </label>

      <span class="inline-block ml-auto" v-if="collection['caption']">
        {{ collection.caption }}
      </span>
    </div>

    <a v-if="showMax != null" href="#" @click.prevent="showMore = !showMore"> See More </a>
  </div>
</template>

<script>
export default {
  name: "Side.RadioSelect",
  props: {
    collections: Array,
    selected: {
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    showMax: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      showMore: this.showMax ? false : true,
    }
  },
  methods: {
    labelName(label) {
      return `${this.type}-${label}-radio`
    },
    toggleSelect(e) {
      const { value } = e.target
      this.$emit("select", { [this.type]: value })
    },
    isSelected(value) {
      return this.selected == value
    },
  },
  computed: {
    shownCollections() {
      return this.collections && this.showMax && !this.showMore
        ? this.collections.slice(0, this.showMax)
        : this.collections
    },
  },
}
</script>

<style lang="scss" scoped>
.RadioSelect_label {
  cursor: pointer;

  .radio-is-selected {
    visibility: hidden;
  }

  &.active .radio-ico {
    @apply text-primary;

    .radio-is-selected {
      visibility: visible;
    }
  }
}
</style>
